
const state = {
  errorMessage: null,
  hideDefault: false
}

const mutations = {
  addError (state, payload) {
    let errorMessage = 'Server Error. Please try again later.'
    state.errorMessage = payload ? payload.errorMessage : errorMessage
    state.hideDefault = payload ? payload.hideDefault : false
  },

  removeError (state) {
    state.errorMessage = null
  }
}

const getters = {
  errorMessage (state) {
    return state.errorMessage
  },

  hideDefault (state) {
    return state.hideDefault
  }
}

const actions = {
  addError (context, payload) {
    context.commit('addError', payload)
  },

  removeError (context) {
    context.commit('removeError')
  }

}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/error.js